import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router';
import { IonContent, IonPage, IonList, IonButton, IonIcon, IonText, IonGrid, IonRow, IonCol, IonicSwiper, IonImg, useIonViewWillEnter, useIonViewDidLeave, IonRefresher, IonRefresherContent } from '@ionic/react';
import { search, calendarOutline, airplane, filterOutline, checkmark } from 'ionicons/icons';
import { Storage } from '@capacitor/storage';
import { useHistory } from 'react-router-dom';
import { Constants } from '../defines/Constants';
import { Pagination } from 'react-rainbow-components';
import { ShowSwal, TimeFormat, DurationMinutes } from '../defines/Functions';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import CurrencyFormat from 'react-currency-format';
import 'swiper/swiper-bundle.min.css';
import moment from 'jalali-moment';
import axios from "axios";
import FlightSort from '../components/search/modals/FlightSort';
import FlightFilter from '../components/search/modals/FlightFilter';
import FlightCard from '../components/search/FlightCard';
import Splash from '../components/Splash';
import './FlightSearch.css';
import clockImg from '../assets/images/clock.svg';
import warningSign from '../assets/images/warning.svg';
import nextImg from '../assets/images/filter-next.svg';
import prevImg from '../assets/images/filter-prev.svg';

SwiperCore.use([IonicSwiper, Navigation]);
const FlightSearch = (props: any) => {
    const searchType = props.location.search.split('=')[1];
    const originalData = useRef({});
    const history = useHistory();
    const expireTime = useRef(900000);
    const expireInterval = useRef<any>(null);
    const currentPage = useLocation();
    const swalOptions = {
        html: '<div class="swal-html"><small><b>پایان زمان جستجو!</b></small><h6 class="title">مدت زمان اعتبار نتایج جستجو به اتمام رسید</h6><p>به منظور بروزرسانی قیمت ها لطفا جستجوی خود را از ابتدا انجام دهید.</p></div>',
        iconHtml: '<img src="' + clockImg + '" width="100" />',
        customClass: {
            container: ''
        },
        backdrop: true,
        allowOutsideClick: false,
        showConfirmButton: true,
        confirmButtonText: 'جستجوی مجدد',
        confirmButtonColor: '#333D79',
        showDenyButton: false,
        denyButtonText: '',
        denyButtonColor: '',
        isConfirmed: () => history.replace('/home'),
        isDenied: () => { }
    }
    if (currentPage.pathname !== '/search/flight') {
        clearInterval(expireInterval.current);
    }
    useIonViewDidLeave(() => {
        clearInterval(expireInterval.current);
    })
    let perPage = 10;
    const myRef = useRef<HTMLDivElement>(null);
    if (myRef.current) {
        var myRefCurrent = myRef.current;
    }
    const [swiperState, setSwiperState] = useState<any>(null);
    const [searchData, setSearchData] = useState({});
    const [flightCalendar, setFlightCalendar] = useState({
        data: [],
        activeSlide: 0
    });
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        totalPages: 5,
        activePage: 1,
        flightData: [],
        errorMessage: '',
        flightDefines: {
            cabinClass: '',
            targetName: '',
            all: {} as any
        },
        sortBy: 'priceAsc',
        filters: {
            routeWent: {
                airlinesRouteWent: [] as any,
                stopsRouteWent: [] as any,
                timesRouteWent: [] as any,
                durationRouteWent: {
                    lower: 0 as number,
                    upper: 0 as number
                }
            },
            routeReturn: {
                airlinesRouteReturn: [] as any,
                stopsRouteReturn: [] as any,
                timesRouteReturn: [] as any,
                durationRouteReturn: {
                    lower: 0 as number,
                    upper: 0 as number
                }
            },
            ticketPrice: {
                lower: 0 as number,
                upper: 0 as number
            }
        },
        toggleCalendar: false
    });
    const showRemoveFilter = useRef(false);
    const getFlightJson = async () => {
        const { value } = await Storage.get({ key: 'flightJson' });
        if (value !== null) {
            return JSON.parse(value);
        }
    };
    const handleData = function (data: any) {
        setSearchData(data);
        if (data.pricedItineraries) {
            state.flightDefines.targetName = data.targetName;
            let pricedItinerariesData = data.pricedItineraries.pricedItinerary;
            let totalAmount, equivFareAmount, discountAmount, discountPercent;
            let itineraryItems = [] as any;
            if (state.filters.ticketPrice.lower && state.filters.ticketPrice.upper) {
                showRemoveFilter.current = true;
                pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                    let itemSearchEl = item.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount;
                    return (itemSearchEl >= state.filters.ticketPrice.lower && itemSearchEl <= state.filters.ticketPrice.upper);
                })
            }
            if (Object.keys(state.filters.routeWent.airlinesRouteWent).length !== 0) {
                showRemoveFilter.current = true;
                pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                    let itemSearchEl = item.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].operatingAirline.code;
                    let foundItem = state.filters.routeWent.airlinesRouteWent.filter((element: any) => {
                        return itemSearchEl === element.code;
                    });
                    return (foundItem.length ? true : false);
                })
            }
            if (Object.keys(state.filters.routeWent.stopsRouteWent).length !== 0) {
                showRemoveFilter.current = true;
                pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                    let itemSearchEl = item.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment.length - 1;
                    let foundItem = state.filters.routeWent.stopsRouteWent.filter((element: any) => {
                        return itemSearchEl === element.value;
                    });
                    return (foundItem.length ? true : false);
                })
            }
            if (Object.keys(state.filters.routeWent.timesRouteWent).length !== 0) {
                showRemoveFilter.current = true;
                pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                    let itemSearchEl: number;
                    let myTime = TimeFormat(item.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime);
                    myTime = myTime.replace(':', '.');
                    if (myTime < 8) {
                        itemSearchEl = 1;
                    } else if (myTime < 11 && myTime >= 8) {
                        itemSearchEl = 2;
                    } else if (myTime < 14 && myTime >= 11) {
                        itemSearchEl = 3;
                    } else if (myTime < 17 && myTime >= 14) {
                        itemSearchEl = 4;
                    } else if (myTime < 21 && myTime >= 17) {
                        itemSearchEl = 5;
                    } else if (myTime >= 21) {
                        itemSearchEl = 6;
                    }
                    let foundItem = state.filters.routeWent.timesRouteWent.filter((element: any) => {
                        return itemSearchEl === element.value;
                    });
                    return (foundItem.length ? true : false);
                })
            }
            if (state.filters.routeWent.durationRouteWent.lower && state.filters.routeWent.durationRouteWent.upper) {
                showRemoveFilter.current = true;
                pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                    let itemSearchEl = DurationMinutes(item.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime, item.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[item.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment.length - 1].arrivalDateTime);
                    return (itemSearchEl >= state.filters.routeWent.durationRouteWent.lower && itemSearchEl <= state.filters.routeWent.durationRouteWent.upper);
                })
            }
            if (searchType === 'roundtrip') {
                if (Object.keys(state.filters.routeReturn.airlinesRouteReturn).length !== 0) {
                    showRemoveFilter.current = true;
                    pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                        let itemSearchEl = item.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].operatingAirline.code;
                        let foundItem = state.filters.routeReturn.airlinesRouteReturn.filter((element: any) => {
                            return itemSearchEl === element.code;
                        });
                        return (foundItem.length ? true : false);
                    })
                }
                if (Object.keys(state.filters.routeReturn.stopsRouteReturn).length !== 0) {
                    showRemoveFilter.current = true;
                    pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                        let itemSearchEl = item.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment.length - 1;
                        let foundItem = state.filters.routeReturn.stopsRouteReturn.filter((element: any) => {
                            return itemSearchEl === element.value;
                        });
                        return (foundItem.length ? true : false);
                    })
                }
                if (Object.keys(state.filters.routeReturn.timesRouteReturn).length !== 0) {
                    showRemoveFilter.current = true;
                    pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                        let itemSearchEl: number;
                        let myTime = TimeFormat(item.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].departureDateTime);
                        myTime = myTime.replace(':', '.');
                        if (myTime < 8) {
                            itemSearchEl = 1;
                        } else if (myTime < 11 && myTime >= 8) {
                            itemSearchEl = 2;
                        } else if (myTime < 14 && myTime >= 11) {
                            itemSearchEl = 3;
                        } else if (myTime < 17 && myTime >= 14) {
                            itemSearchEl = 4;
                        } else if (myTime < 21 && myTime >= 17) {
                            itemSearchEl = 5;
                        } else if (myTime >= 21) {
                            itemSearchEl = 6;
                        }
                        let foundItem = state.filters.routeReturn.timesRouteReturn.filter((element: any) => {
                            return itemSearchEl === element.value;
                        });
                        return (foundItem.length ? true : false);
                    })
                }
                if (state.filters.routeReturn.durationRouteReturn.lower && state.filters.routeReturn.durationRouteReturn.upper) {
                    showRemoveFilter.current = true;
                    pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                        let itemSearchEl = DurationMinutes(item.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].departureDateTime, item.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[item.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment.length - 1].arrivalDateTime);
                        return (itemSearchEl >= state.filters.routeReturn.durationRouteReturn.lower && itemSearchEl <= state.filters.routeReturn.durationRouteReturn.upper);
                    })
                }
            }
            let totalPages = Math.ceil(pricedItinerariesData.length / perPage);
            [].concat(pricedItinerariesData).sort((a: any, b: any) =>
                state.sortBy === 'priceAsc' ?
                    (a.airItineraryPricingInfo.itinTotalFare[0].totalFare.amount > b.airItineraryPricingInfo.itinTotalFare[0].totalFare.amount ? 1 : -1)
                    : state.sortBy === 'priceDesc' ?
                        (a.airItineraryPricingInfo.itinTotalFare[0].totalFare.amount < b.airItineraryPricingInfo.itinTotalFare[0].totalFare.amount ? 1 : -1)
                        : state.sortBy === 'timeAsc' ?
                            (new Date(a.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime).getTime() > new Date(b.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime).getTime() ? 1 : -1)
                            :
                            (new Date(a.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime).getTime() < new Date(b.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime).getTime() ? 1 : -1)
            ).forEach((itinerary: any) => {
                totalAmount = itinerary.airItineraryPricingInfo.itinTotalFare[0].totalFare.amount;
                equivFareAmount = itinerary.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount;
                discountAmount = totalAmount - equivFareAmount;
                discountPercent = (discountAmount * 100 / totalAmount);
                itinerary.discountPercentage = discountPercent;
                itineraryItems.push(itinerary);
            });
            setState({ ...state, flightData: itineraryItems, totalPages: totalPages, activePage: 1, errorMessage: totalPages === 0 ? 'نتیجه ای یافت نشد!' : '' });
            setLoading(false);
        } else {
            // TODO error
            setState({ ...state, flightData: [] });
        }
    }
    const fetchAirLowfareSearch = async (action = 'normal', calendarDate = null as any) => {
        const valueJson = await getFlightJson();
        state.flightDefines.all = valueJson;
        state.flightDefines.cabinClass = valueJson.other.cabin;
        const airLowfareSearch = Constants.api.flightsSearch;
        let xmlData = '<OTA_AirLowFareSearchRQ>';
        if (searchType !== 'multiple') {
            xmlData += '<OriginDestinationInformation>';
            if (action === 'next') {
                valueJson.routes[0].dates.departure = moment(valueJson.routes[0].dates.departure, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
                valueJson.routes[0].dates.departureJalali = moment(valueJson.routes[0].dates.departureJalali, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
                valueJson.routes[0].dates.departureJalaliFormatted = moment(valueJson.routes[0].dates.departureJalaliFormatted, "YYYY-MM-DD").add(1, 'days').format("YYYY/MM/DD");
            } else if (action === 'prev') {
                valueJson.routes[0].dates.departure = moment(valueJson.routes[0].dates.departure, "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
                valueJson.routes[0].dates.departureJalali = moment(valueJson.routes[0].dates.departureJalali, "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
                valueJson.routes[0].dates.departureJalaliFormatted = moment(valueJson.routes[0].dates.departureJalaliFormatted, "YYYY-MM-DD").subtract(1, 'days').format("YYYY/MM/DD");
            } else if (action === 'calendar') {
                valueJson.routes[0].dates.departure = moment(calendarDate, "YYYY-MM-DD").format("YYYY-MM-DD");
                valueJson.routes[0].dates.departureJalali = moment(calendarDate, "YYYY-MM-DD").locale('fa').format("YYYY-MM-DD");
                valueJson.routes[0].dates.departureJalaliFormatted = moment(calendarDate, "YYYY-MM-DD").locale('fa').format("YYYY/MM/DD");
            }
            xmlData += '<DepartureDateTime>' + valueJson.routes[0].dates.departure + '</DepartureDateTime>';
            if (valueJson.routes[0].from.is_all) {
                xmlData += '<OriginLocation LocationCode="' + valueJson.routes[0].from.code + '"  MultiAirportCityInd="true" />';
            } else {
                xmlData += '<OriginLocation LocationCode="' + valueJson.routes[0].from.code + '" />';
            }
            if (valueJson.routes[0].to.is_all) {
                xmlData += '<DestinationLocation LocationCode="' + valueJson.routes[0].to.code + '"  MultiAirportCityInd="true" />';
            } else {
                xmlData += '<DestinationLocation LocationCode="' + valueJson.routes[0].to.code + '" />';
            }
            xmlData += '</OriginDestinationInformation>';
            if (searchType === 'roundtrip') {
                xmlData += '<OriginDestinationInformation>';
                if (action === 'next') {
                    valueJson.routes[0].dates.arrival = moment(valueJson.routes[0].dates.arrival, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
                } else if (action === 'prev') {
                    valueJson.routes[0].dates.arrival = moment(valueJson.routes[0].dates.arrival, "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
                }
                xmlData += '<DepartureDateTime>' + valueJson.routes[0].dates.arrival + '</DepartureDateTime>';
                if (valueJson.routes[0].to.is_all) {
                    xmlData += '<OriginLocation LocationCode="' + valueJson.routes[0].to.code + '"  MultiAirportCityInd="true" />';
                } else {
                    xmlData += '<OriginLocation LocationCode="' + valueJson.routes[0].to.code + '" />';
                }
                if (valueJson.routes[0].from.is_all) {
                    xmlData += '<DestinationLocation LocationCode="' + valueJson.routes[0].from.code + '"  MultiAirportCityInd="true" />';
                } else {
                    xmlData += '<DestinationLocation LocationCode="' + valueJson.routes[0].from.code + '" />';
                }
                xmlData += '</OriginDestinationInformation>';
            }
        } else {
            valueJson.routes.forEach((item: any) => {
                xmlData += '<OriginDestinationInformation>';
                if (action === 'next') {
                    item.dates.departure = moment(item.dates.departure, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
                    item.dates.departureJalali = moment(item.dates.departureJalali, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
                    item.dates.departureJalaliFormatted = moment(item.dates.departureJalaliFormatted, "YYYY-MM-DD").add(1, 'days').format("YYYY/MM/DD");
                } else if (action === 'prev') {
                    item.dates.departure = moment(item.dates.departure, "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
                    item.dates.departureJalali = moment(item.dates.departureJalali, "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
                    item.dates.departureJalaliFormatted = moment(item.dates.departureJalaliFormatted, "YYYY-MM-DD").subtract(1, 'days').format("YYYY/MM/DD");
                } else if (action === 'calendar') {
                    item.dates.departure = moment(calendarDate, "YYYY-MM-DD").format("YYYY-MM-DD");
                    item.dates.departureJalali = moment(calendarDate, "YYYY-MM-DD").locale('fa').format("YYYY-MM-DD");
                    item.dates.departureJalaliFormatted = moment(calendarDate, "YYYY-MM-DD").locale('fa').format("YYYY/MM/DD");
                }
                xmlData += '<DepartureDateTime>' + item.dates.departure + '</DepartureDateTime>';
                if (item.from.is_all) {
                    xmlData += '<OriginLocation LocationCode="' + item.from.code + '"  MultiAirportCityInd="true" />';
                } else {
                    xmlData += '<OriginLocation LocationCode="' + item.from.code + '" />';
                }
                if (item.to.is_all) {
                    xmlData += '<DestinationLocation LocationCode="' + item.to.code + '"  MultiAirportCityInd="true" />';
                } else {
                    xmlData += '<DestinationLocation LocationCode="' + item.to.code + '" />';
                }
                xmlData += '</OriginDestinationInformation>';
            })
        }
        xmlData += '<TravelPreferences >';
        xmlData += '<CabinPref  Cabin="' + valueJson.other.cabin + '"/>';
        xmlData += '</TravelPreferences>';
        xmlData += '<TravelerInfoSummary>';
        xmlData += '<AirTravelerAvail>';
        xmlData += '<PassengerTypeQuantity Code="ADT" Quantity="' + valueJson.passengers.adults + '"/>';
        xmlData += '<PassengerTypeQuantity Code="CHD" Quantity="' + valueJson.passengers.childs + '"/>';
        xmlData += '<PassengerTypeQuantity Code="INF" Quantity="' + valueJson.passengers.infants + '"/>';
        xmlData += '</AirTravelerAvail>';
        xmlData += '</TravelerInfoSummary>';
        xmlData += '<ProcessingInfo SearchType="STANDARD"/>';
        xmlData += "";
        xmlData += '</OTA_AirLowFareSearchRQ>';
        try {
            const results = await axios.post(airLowfareSearch, xmlData, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
            });
            if (results.data.items.pricedItineraries.pricedItinerary.length) {
                originalData.current = results.data.items;
                handleData(results.data.items);
                expireInterval.current = setInterval(() => {
                    if (expireTime.current === 0) {
                        ShowSwal(swalOptions)
                    }
                    expireTime.current = expireTime.current - 1000;
                }, 1000);
            } else {
                setState({ ...state, flightData: [], errorMessage: 'نتیجه ای یافت نشد!' });
                setLoading(false);
            }
            setFlightJson(valueJson);
            if (searchType !== 'multiple') {
                fetchFlightCalendar();
            }
        } catch (error) {
            console.log(error);
            setState({ ...state, flightData: [], errorMessage: 'نتیجه ای یافت نشد!' });
            setLoading(false);
        }
    }
    const fetchFlightCalendar = async () => {
        const flightCalendarList = Constants.api.flightsCalendarList;
        const valueJson = await getFlightJson();
        let flightCalendarJson = {
            adult: valueJson.passengers.adults,
            cabin: valueJson.other.cabin,
            child: valueJson.passengers.childs,
            date: valueJson.routes[0].dates.departure + "T00:00:00.000Z",
            destination: valueJson.routes[0].to.code,
            infant: valueJson.passengers.infants,
            roundtrip: "F",
            source: valueJson.routes[0].from.code,
            type: "flight"
        }
        try {
            const calendarResults = await axios.post(flightCalendarList, flightCalendarJson, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (calendarResults.data.items.length) {
                let calendarResultsItems = [] as any;
                let currentIndex = 0;
                calendarResults.data.items.forEach((item: any, index: number) => {
                    if (valueJson.routes[0].dates.departure === item.data.date) {
                        item.current = 'T';
                        currentIndex = index;
                    } else {
                        item.current = 'F';
                    }
                    if (item.today === "T") {
                        item.className = "calendar-item today";
                    } else if (item.cheapest === "T") {
                        item.className = "calendar-item cheapest";
                    } else if (item.current === "T") {
                        item.className = "calendar-item current";
                    } else {
                        item.className = "calendar-item";
                    }
                    calendarResultsItems.push(item);
                })
                setFlightCalendar({ data: calendarResultsItems, activeSlide: currentIndex });
            }
        } catch (error) {
            console.log(error);
        }
    }
    useIonViewWillEnter(() => {
        if (!loading) {
            if (swiperState) {
                const timer = setTimeout(() => {
                    swiperState.slideTo(flightCalendar.activeSlide);
                }, 100);
                return () => clearTimeout(timer);
            }
        }
    });
    useIonViewWillEnter(() => {
        setLoading(true);
        fetchAirLowfareSearch();
    })
    const lastItem = state.activePage * perPage;
    const firstItem = lastItem - perPage;
    const flightCard = state.flightData.slice(firstItem, lastItem).map((item: any, index) =>
        <FlightCard key={index + '' + state.activePage} id={index} data={item} flightDefines={state.flightDefines} searchType={searchType} expireTime={expireTime} />
    )
    const setPage = (event: any, page: any) => {
        setState({ ...state, activePage: page });
        setTimeout(() => {
            myRefCurrent.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    }
    const setFlightJson = async (flightJson: any) => {
        await Storage.set({
            key: 'flightJson',
            value: JSON.stringify(flightJson),
        });
    };
    const changeDay = async (action: string, calendarDate = null as any) => {
        clearInterval(expireInterval.current);
        setLoading(true);
        fetchAirLowfareSearch(action, calendarDate);
    }
    const handleFlightSortCallback = (childData: any) => {
        setState({ ...state, sortBy: childData });
        myRefCurrent.scrollIntoView({ behavior: 'smooth' });
    }
    useEffect(() => {
        handleData(searchData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.filters, state.sortBy]);
    const handleFlightFilterCallback = (childData: any) => {
        let ticketPriceArray = [] as any;
        let airlinesRouteWentArray = [] as any;
        let stopsRouteWentArray = [] as any;
        let timesRouteWentArray = [] as any;
        let durationRouteWentArray = [] as any;
        let airlinesRouteReturnArray = [] as any;
        let stopsRouteReturnArray = [] as any;
        let timesRouteReturnArray = [] as any;
        let durationRouteReturnArray = [] as any;
        Object.entries(childData.ticketPrice).filter(([k, v]: any) => k === 'lower' || k === 'upper').forEach((item) => {
            ticketPriceArray.push(item[1]);
        });
        Object.entries(childData.routeWent.airlinesRouteWent).filter(([k, v]: any) => v.checked === true).forEach((item) => {
            airlinesRouteWentArray.push(item[1]);
        });
        Object.entries(childData.routeWent.stopsRouteWent).filter(([k, v]: any) => v.checked === true).forEach((item) => {
            stopsRouteWentArray.push(item[1]);
        });
        Object.entries(childData.routeWent.timesRouteWent).filter(([k, v]: any) => v.checked === true).forEach((item) => {
            timesRouteWentArray.push(item[1]);
        });
        Object.entries(childData.routeWent.durationRouteWent).filter(([k, v]: any) => k === 'lower' || k === 'upper').forEach((item) => {
            durationRouteWentArray.push(item[1]);
        });
        Object.entries(childData.routeReturn.airlinesRouteReturn).filter(([k, v]: any) => v.checked === true).forEach((item) => {
            airlinesRouteReturnArray.push(item[1]);
        });
        Object.entries(childData.routeReturn.stopsRouteReturn).filter(([k, v]: any) => v.checked === true).forEach((item) => {
            stopsRouteReturnArray.push(item[1]);
        });
        Object.entries(childData.routeReturn.timesRouteReturn).filter(([k, v]: any) => v.checked === true).forEach((item) => {
            timesRouteReturnArray.push(item[1]);
        });
        Object.entries(childData.routeReturn.durationRouteReturn).filter(([k, v]: any) => k === 'lower' || k === 'upper').forEach((item) => {
            durationRouteReturnArray.push(item[1]);
        });
        setState({
            ...state,
            filters:
            {
                routeWent: {
                    airlinesRouteWent: airlinesRouteWentArray,
                    stopsRouteWent: stopsRouteWentArray,
                    timesRouteWent: timesRouteWentArray,
                    durationRouteWent: { lower: durationRouteWentArray[0], upper: durationRouteWentArray[1] }
                },
                routeReturn: {
                    airlinesRouteReturn: airlinesRouteReturnArray,
                    stopsRouteReturn: stopsRouteReturnArray,
                    timesRouteReturn: timesRouteReturnArray,
                    durationRouteReturn: { lower: durationRouteReturnArray[0], upper: durationRouteReturnArray[1] }
                },
                ticketPrice: { lower: ticketPriceArray[0], upper: ticketPriceArray[1] },
            }
        });
        myRefCurrent.scrollIntoView({ behavior: 'smooth' });
    }
    const toggleCalendar = () => {
        setState({ ...state, toggleCalendar: !state.toggleCalendar });
        if (!state.toggleCalendar) {
            if (swiperState) {
                const timer = setTimeout(() => {
                    swiperState.slideTo(flightCalendar.activeSlide);
                }, 100);
                return () => clearTimeout(timer);
            }
        }
    }
    const removeFilter = () => {
        setState({
            ...state, filters: {
                routeWent: {
                    airlinesRouteWent: [] as any,
                    stopsRouteWent: [] as any,
                    timesRouteWent: [] as any,
                    durationRouteWent: {
                        lower: 0 as number,
                        upper: 0 as number
                    }
                },
                routeReturn: {
                    airlinesRouteReturn: [] as any,
                    stopsRouteReturn: [] as any,
                    timesRouteReturn: [] as any,
                    durationRouteReturn: {
                        lower: 0 as number,
                        upper: 0 as number
                    }
                },
                ticketPrice: {
                    lower: 0 as number,
                    upper: 0 as number
                }
            }
        });
        showRemoveFilter.current = false;
        myRefCurrent.scrollIntoView({ behavior: 'smooth' });
    }
    function doRefresh() {
        window.location.reload();
    }
    return (
        <IonPage className="flight-search-page page-padding-top">
            <IonContent fullscreen>
                <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <div className="ion-padding" ref={myRef}>
                    {state.errorMessage.trim() !== '' ?
                        <>
                            <div className="box-error">
                                <IonImg src={warningSign} />
                                <p>{state.errorMessage}</p>
                            </div>
                            <IonButton color="warning" expand="block" onClick={() => history.replace('/home')}>
                                تغییر جستجو
                                <IonIcon icon={search} className="ion-margin-start" />
                            </IonButton>
                        </>
                        : state.flightDefines.all.routes && !loading &&
                        <>
                            <React.Fragment>
                                <div className="flight-search-info">
                                    <span>مسیر {state.flightDefines.all.routes[0].from.city_fa} به {state.flightDefines.all.routes[0].to.city_fa} - </span>
                                    <span>تاریخ رفت : {state.flightDefines.all.routes[0].dates.departureJalaliFormatted} - </span>
                                    {searchType === 'roundtrip' &&
                                        <span>تاریخ برگشت : {state.flightDefines.all.routes[0].dates.arrivalJalaliFormatted} - </span>
                                    }
                                    <span> {state.flightDefines.all.passengers.adults} مسافر بزرگسال </span>
                                    {state.flightDefines.all.passengers.childs !== 0 &&
                                        <span> / {state.flightDefines.all.passengers.childs} مسافر کودک </span>
                                    }
                                    {state.flightDefines.all.passengers.infants !== 0 &&
                                        <span> / {state.flightDefines.all.passengers.infants} مسافر نوزاد </span>
                                    }
                                </div>
                                <IonGrid className="flight-search-action-btns">
                                    <IonRow>
                                        {searchType === 'oneway' &&
                                            <IonCol size="6">
                                                <IonButton color="primary" expand="block" onClick={toggleCalendar} className={state.flightData.length ? '' : 'disabled'}>
                                                    تقویم قیمتی
                                                    <IonIcon icon={calendarOutline} className="ion-margin-start" />
                                                </IonButton>
                                            </IonCol>
                                        }
                                        <IonCol size={searchType !== 'oneway' ? '12' : '6'}>
                                            <IonButton color="warning" expand="block" onClick={() => history.replace('/home')}>
                                                تغییر جستجو
                                                <IonIcon icon={search} className="ion-margin-start" />
                                            </IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                                <div className={state.toggleCalendar ? "flight-calendar show" : "flight-calendar hide"}>
                                    <Swiper dir="rtl" slidesPerView={3} spaceBetween={10} navigation={true} onSwiper={setSwiperState}>
                                        {flightCalendar.data.map((item: any, index) =>
                                            item.data.price ?
                                                <SwiperSlide key={'index' + index} onClick={() => changeDay('calendar', item.data.date)}>
                                                    <div className={item.className}>
                                                        {item.today === 'T' && <IonIcon icon={checkmark} />}
                                                        {item.cheapest === 'T' && <IonIcon icon={filterOutline} />}
                                                        {item.current === 'T' && <IonIcon icon={airplane} />}
                                                        <span>{moment(item.data.date).locale('fa').format('MM/DD')}</span>
                                                        <span>
                                                            <CurrencyFormat value={item.data.price} displayType={'text'} thousandSeparator={true} />
                                                        </span>
                                                        <span>
                                                            {moment(item.data.date).locale('fa').format('dddd')}
                                                        </span>
                                                        <IonImg src={Constants.airlines + item.data.airline_code + '.png'} />
                                                    </div>
                                                </SwiperSlide>
                                                :
                                                null
                                        )}
                                    </Swiper>
                                </div>
                                <div className="flight-search-description">
                                    <IonText>
                                        قیمت ها به صورت مجموع و بر اساس تعداد مسافرین انتخابی شما محاسبه شده است
                                    </IonText>
                                </div>
                            </React.Fragment>
                            <IonList>
                                <React.Fragment key={'ReactFragment'}>
                                    {state.totalPages > 0 &&
                                        <React.Fragment>
                                            {flightCard}
                                            <div className="my-pagination">
                                                <span>صفحه {state.activePage} از {state.totalPages}</span>
                                                {state.totalPages > 1 &&
                                                    <Pagination
                                                        pages={state.totalPages}
                                                        activePage={state.activePage}
                                                        onChange={setPage}
                                                    />
                                                }
                                            </div>
                                            <div className="total-records">
                                                مجموع پرواز های یافت شده {state.flightData.length}
                                            </div>
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            </IonList>
                        </>
                    }
                    {showRemoveFilter.current &&
                        <IonButton color="danger" expand="block" onClick={() => { removeFilter() }} className="remove-filters-btn">
                            حذف فیلترها
                        </IonButton>
                    }
                </div>
                {loading &&
                    <Splash showText={true} />
                }
            </IonContent>
            {state.flightDefines.all.routes && !loading &&
                <div className="flight-search-filter-btns">
                    <FlightSort flightSortParentCallback={handleFlightSortCallback} disabled={state.flightData.length ? false : true} />
                    <FlightFilter
                        data={originalData.current}
                        flightFilterParentCallback={handleFlightFilterCallback}
                        filters={state.filters}
                        searchType={searchType}
                        disabled={state.flightData.length ? false : true}
                    />
                    <span onClick={() => changeDay('prev')} className={state.flightDefines.all.routes[0].dates.departure === moment.utc().format('YYYY-MM-DD') ? 'disabled' : ''}>
                        <IonIcon icon={prevImg} />
                        روز قبل
                    </span>
                    <span onClick={() => changeDay('next')}>
                        روز بعد
                        <IonIcon icon={nextImg} />
                    </span>
                </div>
            }
        </IonPage >
    );
};

export default FlightSearch;